module.exports = __webpack_public_path__ + "img/stair-up.4e38fb1b.svg";